import { render } from "./MyPageReviewPostDone.vue?vue&type=template&id=709b0a7d"
import script from "./MyPageReviewPostDone.vue?vue&type=script&lang=js"
export * from "./MyPageReviewPostDone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__